import React from 'react';
import { useT } from '../../i18n/LocaleContext';

export default function EmptyState({ icon = '✦', title, body, action }) {
  const t = useT();
  return (
    <div className="empty-state">
      <div className="empty-state__icon" aria-hidden>{icon}</div>
      <div className="empty-state__title">{title || t('common.no_data')}</div>
      {body && <div className="empty-state__body">{body}</div>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
